import React, { useContext, useEffect, useState } from "react";
import Loader from "react-block-ui/lib/Loader";
import { Button, Grid } from "react-bootstrap";
import ApiClient from "../../utils/ApiClient";
import { getCampaignsByClient, getClientId, getLeadsById } from "../api";
import DashboardNav from "../dashboard/components/navbar/Navbar";
import CampaniaStats from "./components/CampaniaStats";
import SelectCampania from "./components/SelectCampania";
import { withRouter } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { Typography } from "@material-ui/core";

const styles = {
    center: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    loader: {
        width: "100%",
        height: "300px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    alert: {
        width: "100%",
        height: "300px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    },
};

const Reportes = ({ location }) => {
    let params = new URLSearchParams(location.search);
    const hash = params.get("hash");

    const { user, setUser, campanias, setCampanias } = useContext(UserContext);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [leads, setLeads] = useState(null);

    async function getData() {
        setLoading(true);
        await getClientId()
            .then((res) => {
                setUser({ idCliente: res.data });
                getCampaigns(res.data);
            })
            .catch((err) => {
                setLoading(false);
                setError("Ocurrio un error inesperado");
            });
    }

    async function getCampaigns(id) {
        try {
            const res = await getCampaignsByClient(id);
            setCampanias(res.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setError("Ocurrio un error al cargar las campañas");
        }
    }

    //trae leads de una campaña
    async function getLeads(hash) {
        //buscar id de campaña
        const [campania] = campanias.filter((camp) => camp.hash === hash);
        if (campania) {
            try {
                setLoading(true);
                const res = await getLeadsById(campania.id);
                setLeads(res.data);
                setLoading(false);
            } catch (error) {
                //setError("Error de red");
                setError("No se encontraron datos para esta Campaña");
                setLoading(false);
                console.log(error);
            }
        } else {
            setError("No se encontro la Campaña");
        }
    }

    useEffect(() => {
        //obtengo datos del cliente y campañas
        if (!user.idCliente) {
            getData();
        } else {
            getCampaigns(user.idCliente);
        }
    }, []);

    useEffect(() => {
        if (hash && campanias.length) {
            getLeads(hash);
        }
    }, [hash, campanias]);

    return (
        <div>
            <DashboardNav />

            {error && (
                <div style={styles.alert}>
                    <Typography component={"span"} style={{ fontSize: "16px" }}>
                        {error}
                    </Typography>
                    <Button
                        style={{ alignSelf: "center", marginTop: "16px" }}
                        bsStyle="primary"
                        id="btn-primary"
                        onClick={() =>
                            window.location.assign(
                                `${window.location.origin}/reportes`
                            )
                        }
                    >
                        Ir a Reportes
                    </Button>
                </div>
            )}

            {loading && !error && (
                <div style={styles.loader}>
                    <div>Cargando</div>
                    <Loader />
                </div>
            )}

            {!loading && !error && (
                <Grid
                    item
                    xs={11}
                    sm={10}
                    md={8}
                    lg={6}
                    xl={5}
                    style={styles.center}
                >
                    <SelectCampania campanias={campanias} hash={hash} />

                    {leads && <CampaniaStats leads={leads} />}
                </Grid>
            )}
        </div>
    );
};

export default withRouter(Reportes);



// WEBPACK FOOTER //
// ./src/scenes/reportes/Reportes.js